module.exports = __webpack_public_path__ + "static/media/app_store.ebdcadff.svg";